import { Text, View } from 'react-native'
import { Gift } from 'lucide-react-native'
import { useTranslation } from 'react-i18next'
import { colors } from '@chillout/core'
import { ToggleSwitch } from '@chillout/ui'

interface BirthdayRewardEnableSectionProps {
  stepNumber: number
  enabled: boolean
  onEnabledChange: (enabled: boolean) => void
}

export function BirthdayRewardEnableSection({ stepNumber, enabled, onEnabledChange }: BirthdayRewardEnableSectionProps) {
  const { t } = useTranslation()

  return (
    <View className="gap-5 rounded-xl border border-border bg-canvas-card p-6">
      <View className="flex-row items-start justify-between gap-4">
        <View className="min-w-0 flex-1">
          <View className="flex-row items-baseline gap-2">
            <Text className="text-lg font-semibold text-primary">{stepNumber}.</Text>
            <Text className="text-lg font-semibold text-primary">{t('birthdayReward.enable.sectionTitle')}</Text>
          </View>
          <Text className="mt-1 text-sm text-secondary">{t('birthdayReward.enable.subtitle')}</Text>
        </View>
        <View className="flex-row items-center gap-2">
          <ToggleSwitch
            value={enabled}
            onValueChange={onEnabledChange}
            accessibilityLabel={t('birthdayReward.enable.toggleAccessibilityLabel')}
          />
          <Text className="text-sm font-semibold text-primary">
            {enabled ? t('birthdayReward.enable.enabled') : t('birthdayReward.enable.disabled')}
          </Text>
        </View>
      </View>

      <View className="flex-row items-center gap-3 rounded-lg bg-accent/5 p-4">
        <View className="h-8 w-8 items-center justify-center rounded-full bg-accent/10">
          <Gift size={16} color={colors.accent.DEFAULT} strokeWidth={2} />
        </View>
        <Text className="flex-1 text-sm text-primary">{t('birthdayReward.enable.info')}</Text>
      </View>
    </View>
  )
}
